import { api } from '../../../index';
import { StepResponse } from '../../types/useStep.type';

export const getSteps = async (id: string): Promise<StepResponse> => {
  return await api.get<StepResponse>(`onboarding/document/${id}`);
};
